export enum CompanyContactPersonsTableAccessor {
  EmailAddress = 'email',
  FirstName = 'firstName',
  FullName = 'fullName',
  IsPrimary = 'isPrimary',
  LastName = 'lastName',
}
